import React from "react";

interface Props {
    id: string;
    text: string;
    style?: React.CSSProperties;
}

const InfoText = (props: Props) => {
    const { id, style, text } = props;
    return (
        <p
            id={id}
            style={{
                fontWeight: 500,
                color: "#646363",
                marginBottom: 0,
                width: "100%",
                ...style,
            }}
            tabIndex={0}
        >
            {text}
        </p>
    );
};

export default InfoText;



// WEBPACK FOOTER //
// ./src/components/form/QuestionParameters/InfoText.tsx